import { createApp } from 'vue'
import App from '@/App.vue'
import router from '@/scripts/router'
import { FontAwesomeIcon } from '@/scripts/icons'
import { VueQueryPlugin } from '@tanstack/vue-query'
import { queryClient } from '@/scripts/queryClient'

const app = createApp(App)
app.component('font-awesome-icon', FontAwesomeIcon)
app.use(router)
app.use(VueQueryPlugin, { queryClient })
app.mount('#app')
